import { $color } from "@/utils/cssVarUtils"
import { breadcrumbAnatomy as parts } from "@chakra-ui/anatomy"
import {
  PartsStyleObject,
  SystemStyleObject,
} from "@chakra-ui/theme-tools"


const baseStyleSeparator: SystemStyleObject = {
  color: $color('bg-text-masked'),
}

const baseStyleLink: SystemStyleObject = {
  _hover: {
    textDecoration: "none",
    color: $color('scene-primary-normal'),
  },
  _focus: {
    boxShadow: 'none',
  },
}

const baseStyle: PartsStyleObject<typeof parts> = {
  link: baseStyleLink,
  separator: baseStyleSeparator,
}

const baseSizes: Record<string, PartsStyleObject<typeof parts>> = {
  md: {
    link: {
      // fontSize: 'xs',
    },
  },
}

const defaultProps = {
  size: 'md',
}

export const Breadcrumb = {
  parts: parts.keys,
  baseStyle,
  defaultProps,
  sizes: baseSizes,
}